<template>
   <div>
   <div class="row">
       <div class="col-18"><div v-if="product.PackageID != undefined" class="packageInfo">PAKKET</div>
            <strong>{{product.Title}}</strong>
       </div>
       <div class="col-6" style="text-align:right">
           <div><span v-if="!getPrice">&euro;{{product.Price}}&nbsp;</span><cartdel-button :product="product" v-if="!hidedetails"></cartdel-button>&nbsp;&nbsp;</div>
       </div>
   </div>
   <div class="row" v-if="isTrimSalon()" style="padding-bottom:8px">
       <div class="col-10" style="margin-top:15px">Naam dier</div>
       <div class="contact-message col-12">
            <input name="last_name" placeholder="Vul naam in" type="text" v-model="product.Extra">   
       </div>
   </div>
   <div class="row"  v-if="product.PriceAdvance !== 0">
     <div class="col-18"><strong style="color:#ff0000">Online voorschot gevraagd van </strong></div>
     <div class="col-6" style="color:#ff0000;text-align:right">&euro;{{getPriceAdv ()}}&nbsp;&nbsp;</div>
   </div>
   </div>
</template>

<script>
import Vue from 'vue';
import CartDelButton from './CartDelButton';
  export default {
    props: ['product', 'hidedetails'],
    data () {
      return {
        cart: this.$store.state.cart
      }
    },
    components: {
        cartdelButton : CartDelButton
    },
    methods: {
      getPriceAdv () {
           return this.product.PriceAdvance.toFixed(2)
      },
      isTrimSalon () {
        if (Vue.$storeSettings.KindStore === undefined) return false;
        if (Vue.$storeSettings.KindStore === 15) return true;
        return false;
      }
    },
    computed: {
      getPrice () {
           if (this.product.Price == "0") {return true;}
           return Vue.$storeSettings.IsHidePrices;
       }
     }
  }
</script>
<style scoped>
 .packageInfo {
   background-color:#585858;
   border-radius:5px;
   float:left;
   padding-left:5px;
   padding-right:5px;
   margin-right:10px;
   color: #ffffff;
   font-size: smaller;
 }
</style>


// WEBPACK FOOTER //
// src/components/cart/CartItem.vue